
import { useSelector } from "react-redux";
import Icon from "@identitybuilding/idb-react-iconlib";
import React from "react";
import '../assets/css/Footer.css'


const Footer = () => {

	const translate = useSelector(state => state.general.translate);
	const lang = useSelector(state => state.general.lang);

	// Client-provided privacy pages, served as static files from /public/privacy
	const privacyPolicyPaths = {
		nl: "/privacy/privacybeleid_nl.html",
		fr: "/privacy/privacybeleid_fr.html",
		en: "/privacy/privacybeleid_en.html",
		de: "/privacy/privacybeleid_de.html",
	};
	const privacyPolicyHref = `${process.env.PUBLIC_URL}${privacyPolicyPaths[lang] || privacyPolicyPaths.nl}`;
	let social = [
		// { class: "idb", text: "BE0718.600.051", url: "https://identitybuilding.be", image: require('../assets/imgs/logos/idb/logo_idb_secundair.svg').default },
		{ class: "idb", text: "BE1013.506.478", url: "https://idbforge.be", image: require('../assets/imgs/logos/idb/created-by-idBForge_grey.svg').default },
		// { class: "fb", icon: "Facebook", url: "https://facebook.com/identityBuildingBelgium" },
		// { class: "insta", icon: "Instagram", url: "https://instagram.com/identitybuilding/" },
		// { class: "li", icon: "Linkedin", url: "https://linkedin.com/company/ondernemersnetwerk/about/" },
	]
	
	return (
		<footer>
			<div className="footerWrapper">

				{/* Information about identityBuilding bv */}
				<div className="footerSocial">
					{social.map(item => (
						<a className={item.class} href={item.url} key={item.class} rel="noopener noreferrer" target="_blank">
							{/* {item.type ? <Icon name={item.type} />
								: <h2>{item.text}</h2>} */}
							<figure><img width='125' height='25px' src={item.image} alt={item.text} /></figure>
							{item.text}
						</a>
					))}
				</div>

				{/* Privacy message */}
				<div className="footerProtection">
					<a href="https://www.ondernemersnetwerk.be/#privacy" target="_blank" rel="noopener noreferrer">
						<Icon name="Protection" />
						<span>{translate("how_do_we_protect")}</span>
					</a>
				</div>

				{/* Links to our privacy pages */}
				<div className="footerPrivacy">
					<a href="mailto:support@stad-gemeente.be">{translate("support")}</a>
					<a href={privacyPolicyHref} target="_blank" rel="noopener noreferrer">{translate("privacy_policy")}</a>
					<a href="https://www.ondernemersnetwerk.be/privacy/policy#terms">{translate("terms_and_conditions")}</a>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
